import React, { Component } from  'react';
import {
  Image
} from 'react-bootstrap'

class Profile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      profileNum: 1
    }
  }

  render() {
    const m = this.props.margin;
    return <div id="profile-container" className="text-center " style={{marginTop: m.top, marginLeft: m.left, marginBottom: m.bottom, marginRight: m.right}}>
        <Image id="profile-pic" src={`images/p${this.state.profileNum}.jpg`} roundedCircle style={{width: "100%", maxWidth: 250}} onClick={this.clickHandler.bind(this)}/>
      </div>
  }

  clickHandler() {
    let newProfileNum = this.state.profileNum % 10 + 1;
    this.setState({profileNum: newProfileNum});
  }

}

export default Profile;